import {compute, create} from "@targoninc/jess";
import {docsSite} from "./docs-site.ts";
import {skeleton, sidebarSkeleton} from "./skeleton.ts";
import {currentPageContent, pages, mobileMenuOpen} from "../lib/state.ts";
import {sidebar} from "./sidebar.ts";

export function page() {
    return create("div")
        .classes("page", "flex", "no-wrap")
        .children(
            create("div")
                .classes("sidebar-container", compute(open => open ? "mobile-open" : "mobile-closed", mobileMenuOpen))
                .children(
                    compute(p => p.length > 0 ? sidebar(p) : sidebarSkeleton(), pages)
                ).build(),
            compute((c, p) => p.length > 0 ? docsSite(c) : skeleton(), currentPageContent, pages),
        ).build();
}